import { WorkspaceHeader } from './WorkspaceHeader.jsx';
import { RuntimeViewHost, SectionTabsHost } from './RuntimeViewHost.jsx';

export function Workspace() {
  return (
    <main class="workspace">
      <WorkspaceHeader />
      <SectionTabsHost />
      <RuntimeViewHost />
    </main>
  );
}
